import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';
import type { TestimonialDTO, TestimonialPayload } from './types';

export const useUpdateTestimonial = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ id, data: payload }: { id: string; data: Partial<TestimonialPayload> | FormData }) => {
			try {
				const formData = payload instanceof FormData ? payload : createFormData(payload);
				const { data } = await api.put<TestimonialDTO>(`/management/testimonial/update/${id}`, formData);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar depoimento');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['testimonials'] });
			queryClient.invalidateQueries({ queryKey: ['testimonial', variables.id] });
		},
		onError: error =>
			console.error('Erro ao atualizar depoimento:', getApiErrorMessage(error, 'Erro ao atualizar depoimento')),
	});
};
